import React, { useEffect, useState } from 'react';
import './WinAnimation.css';

interface WinAnimationProps {
  amount: number;
  isBonus: boolean;
  onEnd: () => void;
}

export function WinAnimation({ amount, isBonus, onEnd }: WinAnimationProps) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => {
      setVisible(false);
      onEnd();
    }, isBonus ? 2500 : 1800);
    return () => clearTimeout(t);
  }, [isBonus, onEnd]);

  if (!visible) return null;

  return (
    <div className={`win-overlay ${isBonus ? 'bonus' : 'win'}`}>
      <div className="win-confetti" aria-hidden />
      <div className="win-content">
        <div className="win-badge">{isBonus ? 'BONUS' : 'VOITTO'}</div>
        <div className="win-amount">+€{amount}</div>
        {isBonus && <div className="win-sub">Onneksi olkoon!</div>}
      </div>
    </div>
  );
}
